import { Box, Typography } from '@mui/material'
import { BoxWelcome, H1Welcome, H2Welcome, ImageWelcome } from './style'

export const GuestWelcome = () => {
  return (
    <Box>
      <Box sx={BoxWelcome}>
        <Typography variant="h1" sx={H1Welcome}>
          Прогресс
        </Typography>
        <Typography variant="h2" sx={H2Welcome}>
          От идеи — к команде и результату
        </Typography>
      </Box>
      <Box component="img" alt="Welcome image" src="images/welcomeImage.png" sx={ImageWelcome} />
    </Box>
  )
}
